// @flow

import { useMemo } from 'react';

type TranslatedTag = {
  +text: string;
  +tag?: 'support';
}

export function useTranslateErrorMessageTags(message: string): TranslatedTag[] {
  const translation = useMemo(() => {
    return translateErrorMessageTags(message);
  }, [message]);

  return translation;
}

function translateErrorMessageTags(message: string): TranslatedTag[] {
  return translateSupportTag(message);
}

function translateSupportTag(message: string): TranslatedTag[] {
  const messageTag = message.match('(.*)<support>(.*)</support>(.*)');

  if (!messageTag) {
    return [{ text: message }];
  }

  return [
    { text: messageTag[1] },
    { text: messageTag[2], tag: 'support' },
    { text: messageTag[3] },
  ];
}
